/**
 *  des: 高德地图按需引入配置文件
 *  author: 张宗楠
 *  date: 2020-2-21 21:02
 */
export function MapLoader({ plugins }) {
    let key = '977e94a32249c992dea88c68ebd487a7'

    let urls = [`//webapi.amap.com/maps?v=1.4.15&key=${key}&plugin=${plugins.join(',')}&callback=init`, `//webapi.amap.com/loca?v=1.3.0&key=${key}`]

    return new Promise(async (resolve, reject) => {
        // if (window.AMap) {
        //     resolve(window.AMap);
        // } else {
        window.init = async () => {
            window._AMapSecurityConfig = {
                securityJsCode: 'c9eab08fccd96b257b11e5f5d061da6a',
            };
            await syncLoadJs(urls[1])
            setTimeout(resolve(window.AMap), 0)
        }
        await syncLoadJs(urls[0])
        // }
    })
}

export function syncLoadJs(src) {
    return new Promise((resolve, reject) => {
        let script = document.createElement('script')
        script.type = "text/javascript"
        script.src = src
        script.onload = () => {
            setTimeout(resolve, 0)
        }
        document.head.appendChild(script)

    })
}